import { tracked } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SidebarBookingRequestsRepliesReplyController extends BaseController {
  @tracked bookingRequest!: ModelRegistry['booking-request'];
  @tracked savedReply!: ModelRegistry['saved-reply'];
}
